// src/components/bot/components/FormActions.tsx
// 🎨 FORM ACTIONS - Submit and cancel buttons (50 lines)

import React from 'react';
import styles from '../BotForm.module.css';

interface FormActionsProps {
  isEdit: boolean;
  saving: boolean;
  templateLoading: boolean;
  onCancel?: () => void;
  // onSubmit removed - form handles submission through form's onSubmit
}

const FormActions: React.FC<FormActionsProps> = ({
  isEdit,
  saving,
  templateLoading,
  onCancel
}) => {
  return (
    <div className={styles.formActions}>
      <div className={styles.formActionsContainer}>
        
        {/* 🎯 CANCEL BUTTON */}
        {onCancel && (
          <button 
            type="button" 
            onClick={onCancel} 
            className={styles.cancelBtn} 
            disabled={saving}
          >
            Cancel
          </button>
        )}
        
        {/* 🎯 SUBMIT BUTTON */}
        <button 
          type="submit"
          className={styles.submitBtn} 
          disabled={saving || templateLoading}
        >
          {saving ? (
            <>
              <div className={styles.buttonSpinner}></div>
              <span>Saving...</span>
            </>
          ) : (
            <span>{isEdit ? 'Update Bot' : 'Create Bot'}</span>
          )}
        </button>
        
      </div>
    </div>
  );
};

export default FormActions;